import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { API } from "aws-amplify";
import { Layout, Row, Spin, Button, Tabs, Descriptions, Table } from "antd";
import { LeftOutlined } from "@ant-design/icons";

import InventoryTab from "../InventoryTab/InventoryTab";
import PrintItemEventReport from "../../../../components/UI/Modals/PrintItemEventReport/PrintItemEventReport";

const { Header, Content } = Layout;
const ButtonGroup = Button.Group;

const actionColumns = [
  {
    title: "Articulo",
    dataIndex: "itemName",
  },
  {
    title: "Inicial",
    dataIndex: "inicial",
  },
  {
    title: "Agregar",
    dataIndex: "agregar",
  },
  {
    title: "Surtir",
    dataIndex: "surtir",
  },
  {
    title: "Ajustar",
    dataIndex: "ajustar",
  },
  {
    title: "Mermar",
    dataIndex: "mermar",
    render: (e) => (e === 0 ? e : "-" + e),
  },
  {
    title: "Sacar",
    dataIndex: "sacar",
    render: (e) => (e === 0 ? e : "-" + e),
  },
  {
    title: "Venta",
    dataIndex: "venta",
    render: (e) => (e === 0 ? e : "-" + e),
  },
  {
    title: "Remover",
    dataIndex: "remover",
    render: (e) => (e === 0 ? e : "-" + e),
  },
  {
    title: "Final",
    dataIndex: "final",
  },
];

const ItemActionsReportDetails = () => {
  const history = useHistory();
  const { hotelId, startdate, enddate } = useParams();
  const [loading, setLoading] = useState(false);
  const [tabs, setTabs] = useState([]);

  const [printableInventory, setPrintableInventory] = useState("");
  const [printableTable, setPrintableTable] = useState([]);
  const [printProducts, setPrintProducts] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);

    const startDateLabels = generateDateLabels(startdate);
    const endDateLabels = generateDateLabels(enddate);

    const report = await getReport(
      startDateLabels.timestamp,
      endDateLabels.timestamp
    );

    let preProcessedTabs = [];
    const inventories = report?.inventories ?? [];
    inventories.forEach((inventory) => {
      const inventoryTable = (
        <Table
          style={{ width: "80%", paddingLeft: 20, marginBottom: 50 }}
          size="small"
          columns={actionColumns}
          dataSource={inventory.items ?? []}
          rowKey={"inventoryItemId"}
          pagination={false}
        />
      );

      const preTab = {
        key: inventory.id,
        label: inventory.name ?? "-",
        children: (
          <>
            <Row style={{ marginTop: 20, marginBottom: 10, paddingLeft: 20 }}>
              <Descriptions title="Movimientos de inventario" bordered>
                <Descriptions.Item label="Inicio del periodo">
                  {startDateLabels.dateLabel}
                </Descriptions.Item>
                <Descriptions.Item label="Fin del periodo">
                  {endDateLabels.dateLabel}
                </Descriptions.Item>
                <Descriptions.Item label="">
                  {
                    <Button
                      type="primary"
                      onClick={() => {
                        setPrintableInventory(inventory.name);
                        setPrintableTable(inventoryTable);
                        setStartDate(startDateLabels.dateLabel);
                        setEndDate(endDateLabels.dateLabel);
                        setPrintProducts(true);
                      }}
                    >
                      Imprimir
                    </Button>
                  }
                </Descriptions.Item>
              </Descriptions>
            </Row>
            <Row>{inventoryTable}</Row>
          </>
        ),
      };

      preProcessedTabs.push(preTab);
    });
    setTabs(preProcessedTabs);

    setLoading(false);
  };

  const generateDateLabels = (date) => {
    const numDate = parseInt(date, 10);
    const objDate = new Date(numDate);
    const dateLabel = objDate.toDateString();

    const dateForReport =
      objDate.getFullYear() +
      ("0" + (objDate.getMonth() + 1)).slice(-2) +
      ("0" + objDate.getDate()).slice(-2);

    const timestamp = objDate.getTime();

    return { dateLabel, dateForReport, timestamp };
  };

  const getReport = async (startDateTimestamp, endDateTimestamp) => {
    return await API.get(
      "benackoAPI",
      "/v2/reports/inventory-activity?hotelId=" +
        hotelId +
        "&startDate=" +
        startDateTimestamp +
        "&endDate=" +
        endDateTimestamp
    ).catch((err) => console.log("Error loading initial quantities", err));
  };

  return (
    <Layout>
      <Header style={{ background: "#fff", padding: 0 }}>
        <Row>
          <ButtonGroup>
            <Button type="primary" onClick={() => history.goBack()}>
              <LeftOutlined />
              Regresar
            </Button>
          </ButtonGroup>
        </Row>
      </Header>
      <Content style={{ margin: 0, padding: 0, background: "#fff" }}>
        <Spin spinning={loading} size="large">
          <Tabs defaultActiveKey="1" tabPosition="right" items={tabs} />
        </Spin>
      </Content>

      <PrintItemEventReport
        visible={printProducts}
        onCancel={() => setPrintProducts(false)}
        addOnTitle={printableInventory}
        itemTable={printableTable}
        reportDate={startDate + " - " + endDate}
      />
    </Layout>
  );
};

export default ItemActionsReportDetails;
